import AddSupportPage from "../../../component/users/support/AddSupportPage";

 
 
 
function AddUserSupport() {
  return (
    <div className="page-body">
      <AddSupportPage />
    </div>
  );
}

export default AddUserSupport;
